// import _ from 'lodash'
import Vue from 'vue';
import get from 'lodash.get';
import cloneDeep from 'lodash.clonedeep';

import MenuApi from '@/store/api/menu';
import PageApi from '@/store/api/page';

// initial state
const state = {
    page: {},
};

// getters
const getters = {
    sections: (state) => {
        let sections = get(state, 'page.sections') || [];
        return cloneDeep(sections).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
    },
    view: (state) => state.page.view,
    restriction: (state) => state.page.restriction
};

// mutations
const mutations = {
    addPageToState(state, page) {
        state.page = page;
    },
    updateCategoryPostTeasersLoading(state, { s, value }) {
        Vue.set(state.page.sections[s].teasers, 'loading', value);
    },
    insertTeasers(state, { s, teasers }) {
        Vue.set(state.page.sections[s], 'teasers', teasers);
    },
};

// actions
const actions = {
    // eslint-disable-next-line 
    fetchMenuItem({ commit }, { path, cms }) {
        return MenuApi.fetchItem(path, cms);
        // .then(data => commit('addPageToState', data.page))
    },
    // eslint-disable-next-line 
    fetchCategoryPostTeasers({ commit }, payload) {
        return PageApi.fetchPagesPaginated(payload);
    },
    // eslint-disable-next-line 
    fetchCategoryPost({ commit }, payload) {
        return PageApi.fetchPage(payload);
    },
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations,
};
